import { render, staticRenderFns } from "./form-upload.vue?vue&type=template&id=05caf1be"
import script from "./form-upload.vue?vue&type=script&lang=js"
export * from "./form-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports